export const defaultWebsiteConfig = {
  // Basic Website Information
  website: {
    title: "DRONE.COM.HK",
    subtitle: "Creating smarter cities through the integration of drone technologies.",
    description: "Creating smarter cities through the integration of drone technologies.",
    url: "https://drone.com.hk",
    logo: "/ico/drone_color.svg",
    favicon: "/ico/drone_color.svg",
    version: "1.0.0",
    lastUpdated: new Date().toISOString()
  },

  // SEO Configuration
  seo: {
    // Meta Tags
    meta: {
      keywords: "Drone Technology, Smart Cities, STEAM Learning, Urban Development, Emergency Response, Infrastructure Maintenance, Air Taxi, Last-Mile Delivery, IoT Sensors, AI Analytics",
      author: "DRONE.COM.HK Team",
      robots: "index, follow",
      viewport: "width=device-width, initial-scale=1.0",
      charset: "UTF-8",
      language: "en",
      revisitAfter: "7 days",
      distribution: "global",
      rating: "general"
    },

    // Open Graph Tags
    openGraph: {
      type: "website",
      siteName: "DRONE.COM.HK",
      title: "DRONE.COM.HK - Creating Smarter Cities with Drone Technologies",
      description: "Transforming education, entertainment, urban development, logistics, and emergency response through innovative drone technologies.",
      image: "/HK_1920x1080.jpg",
      imageAlt: "DRONE.COM.HK - Smarter Cities Through Drone Technologies",
      url: "https://drone.com.hk",
      locale: "en_US"
    },

    // Twitter Card
    twitter: {
      card: "summary_large_image",
      site: "@hongkongai",
      creator: "@hongkongai",
      title: "DRONE.COM.HK - Creating Smarter Cities with Drone Technologies",
      description: "Transforming education, entertainment, urban development, logistics, and emergency response through innovative drone technologies.",
      image: "/HK_1920x1080.jpg"
    },

    // Structured Data (JSON-LD)
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "DRONE.COM.HK",
      "url": "https://drone.com.hk",
      "logo": "https://drone.com.hk/ico/drone_color.svg",
      "description": "Creating smarter cities through the integration of drone technologies.",
      "foundingDate": "2024",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Hong Kong",
        "addressCountry": "HK"
      },
      "sameAs": [

      ]
    },

    // Security Headers
    security: {
      contentSecurityPolicy: "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline';",
      xFrameOptions: "DENY",
      xContentTypeOptions: "nosniff",
      referrerPolicy: "strict-origin-when-cross-origin"
    }
  },

  // Internationalization Configuration
  i18n: {
    defaultLanguage: "en",
    supportedLanguages: ["en", "sc", "tc", "th"],
    fallbackLanguage: "en",
    languageNames: {
      en: "English",
      sc: "简体中文",
      tc: "繁體中文",
      th: "ไทย"
    },
    dateFormat: {
      en: "MM/DD/YYYY",
      sc: "YYYY年MM月DD日",
      tc: "YYYY年MM月DD日",
      th: "DD/MM/YYYY"
    },
    numberFormat: {
      en: "en-US",
      sc: "zh-CN",
      tc: "zh-TW",
      th: "th-TH"
    }
  },

  // Theme Configuration
  theme: {
    primaryColor: "#007bff",
    secondaryColor: "#6c757d",
    successColor: "#28a745",
    dangerColor: "#dc3545",
    warningColor: "#ffc107",
    infoColor: "#17a2b8",
    lightColor: "#f8f9fa",
    darkColor: "#343a40",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: "16px",
    lineHeight: "1.5"
  },

  // Navigation Configuration
  navigation: {
    header: {
      showLogo: true,
      showLanguageSelector: true,
      showSearch: false,
      sticky: true
    },
    footer: {
      showSocialLinks: true,
      showCopyright: true,
      showPrivacyPolicy: true,
      showTermsOfUse: true
    },
    menu: [
      { key: "home", path: "/", titleKey: "Home", order: 1 },
      { key: "education", path: "/education", titleKey: "Education", order: 2 },
      { key: "urban-development", path: "/urban-development", titleKey: "Urban Development", order: 3 },
      { key: "transportation-logistics", path: "/transportation-logistics", titleKey: "Transportation & Logistics", order: 4 },
      { key: "emergency-response", path: "/emergency-response", titleKey: "Emergency Response", order: 5 },
      { key: "aboutus", path: "/aboutus", titleKey: "About Us", order: 6 }
    ]
  },

  // Analytics Configuration
  analytics: {
    googleAnalytics: {
      enabled: false,
      trackingId: ""
    },
    googleTagManager: {
      enabled: false,
      containerId: ""
    },
    facebookPixel: {
      enabled: false,
      pixelId: ""
    }
  },

  // Performance Configuration
  performance: {
    lazyLoading: true,
    imageOptimization: true,
    caching: {
      enabled: true,
      duration: 3600000 // 1 hour in milliseconds
    },
    compression: {
      enabled: true,
      level: 6
    }
  },

  // Contact Information
  contact: {
    email: "enquiry@drone.com.hk",
    phone: "",
    address: "Hong Kong",
    socialMedia: {

      facebook: "",
      instagram: ""
    }
  },

  // Feature Flags
  features: {
    cookieConsent: true,
    newsletter: false,
    comments: false,
    search: false,
    darkMode: false,
    multiLanguage: true,
    serviceWorker: true
  }
};